module.exports = __webpack_public_path__ + "static/media/Account.d5559981.svg";